export default __webpack_public_path__ + "static/media/flag-hs.2cf03c66.svg";